
    // IMPORTS
    import { defineComponent, PropType } from 'vue'

    export default defineComponent({
        name: 'bitmapLink',

        components: {
        },

        props: {
            src: { type: String as PropType<string>, required: true },
            title: { type: String as PropType<string>, required: true },
            tag: { type: Object as PropType<any>, required: false, default: () => null },
            border: { type: Boolean as PropType<boolean>, required: false, default: () => true },
            selected: { type: Boolean as PropType<boolean>, required: false, default: () => false },
            size: { type: Number as PropType<number | null>, required: false, default: () => null }
        },

        emits: {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            click: (tag: any) => true
        },

        setup(props, { emit }) {
            /********************************************************************************************************************
             PUBLIC DATA
             ********************************************************************************************************************/
            const publicData = { }

            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const computedData = { }

            /********************************************************************************************************************
             PUBLIC METHODS
             ********************************************************************************************************************/
            function onClick() {
                emit('click', props.tag)
            }
            
            const publicMethods = { onClick }

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { ...publicData, ...computedData, ...publicMethods }
        }
    });
